module.exports = __webpack_public_path__ + "static/media/toontown-logo-ultrasmall.a75cd41e.png";